module.exports = __webpack_public_path__ + "img/buy_button_text_web.de1c4b28.png";